import {createStyles, makeStyles} from '@material-ui/core/styles/';

export const useStyles = makeStyles(() => {
  return createStyles({
    wrapperBox: {
      width: '100%'
    },
    homeContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      width: '100%',
      padding: '0 0 0 40px',
      flexDirection: 'row',
      gap: 16,
      backgroundColor: '#FAFAFA'
    },
    homeContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      maxWidth: '800px',
      paddingTop: '40px'
    },
    heading1: {
      fontSize: '2rem',
      color: '#002677',
      marginTop: '16px',
      lineHeight: 1.3
    },
    description: {
      color: '#4B4D4F',
      lineHeight: '28px',
      fontSize: '18px'
    },
    emailRow: {
      color: '#002677',
      fontSize: '16px',
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '4px'
    },
    emailLink: {
      color: '#002677 !important',
      fontWeight: 700,
      textDecoration: 'underline'
    },
    note: {
      marginTop: '36px',
      color: '#4B4D4F',
      fontSize: '14px'
    },
    signInPrompt: {
      color: '#6D6F70',
      fontSize: '14px',
      lineHeight: '26px'
    },
    signBtn: {
      marginTop: '16px',
      minWidth: '140px',
      maxWidth: '180px',
      textTransform: 'none',
      backgroundColor: '#3D3C38'
    },
    bgOverlayImage: {
      height: '100%',
      width: 'auto',
      objectFit: 'contain'
    },
    documentsTitle: {
      marginTop: '28px',
      marginBottom: 0,
      padding: '20px 40px 0',
      color: '#323334',
      fontWeight: 700,
      fontSize: '18px'
    },
    documentsList: {
      marginTop: '20px',
      marginBottom: 0,
      padding: '8px 40px 24px',
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      listStyle: 'none'
    },
    documentItem: {
      color: '#0C55B8',
      textDecoration: 'underline',
      cursor: 'pointer',
      fontSize: '14px',
      '&:last-child': {
        marginTop: '10px'
      }
    },
    documentLink: {
      color: '#0C55B8',
      textDecoration: 'underline',
      fontSize: '14px !important'
    },

    '@media (max-width: 1000px)': {
      wrapperBox: {
        justifyContent: 'center'
      },
      homeContainer: {
        display: 'flex',
        flexDirection: 'column !important',
        justifyContent: 'flex-start',
        gap: 12,
        padding: '24px 24px 0'
      },
      homeContent: {
        maxWidth: '100%',
        gap: 12
      },
      heading1: {
        fontSize: '1.5rem'
      },
      description: {
        fontSize: '16px',
        lineHeight: '24px'
      },
      signInPrompt: {
        fontSize: '16px',
        lineHeight: '24px'
      },
      bgOverlayImage: {
        alignSelf: 'center',
        width: '220px',
        maxWidth: '75%'
      },

      documentsTitle: {
        padding: '16px 24px 0'
      },
      documentsList: {
        padding: '8px 24px 20px'
      }
    }
  });
});
